import React from 'react';
import branding from '../data/branding';
import Profile from './Profile';
import SearchBarHeader from './SearchBarHeader';
import Header from './Header';

const HeaderCombine = (props) => (

    <div className="header-combine">
      <SearchBarHeader type="header-combine-left" 
        specialName="no-height" showProfile={props.showProfile}
        background="" />
      <Header inputClass="header-combine-right" />
    </div>

);

export default HeaderCombine;



// WEBPACK FOOTER //
// ./src/components/HeaderCombine.js